import { render } from "./IndexKios.vue?vue&type=template&id=505b386c"
import script from "./IndexKios.vue?vue&type=script&lang=js"
export * from "./IndexKios.vue?vue&type=script&lang=js"

import "./IndexKios.vue?vue&type=style&index=0&id=505b386c&lang=css"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__